import { IWizardConfig, IWizardStep, WizardMode } from "../../../wizard/types";
import { CreditsContent } from "../viewCredits/CreditsContent";

const viewCreditsConfig: IWizardStep = {
  width: "552px",
  titleConfig: {
    titleText: "Credits",
  },
  content: CreditsContent,
};

export const getCreditConfig = ({
  availableCredits,
  currentPackage,
}): IWizardConfig => {
  if (currentPackage === null) {
    return {
      steps: [viewCreditsConfig],
      submitButtonText: "Go to packages",
      cancelButtonText: "Close",
      mode: WizardMode.View,
      getInitialData: () =>
        new Promise((resolve) => resolve({ availableCredits, currentPackage })),
    };
  } else if (availableCredits === 0) {
    return {
      steps: [viewCreditsConfig],
      submitButtonText: "Go to packages",
      cancelButtonText: "Close",
      mode: WizardMode.View,
      getInitialData: () =>
        new Promise((resolve) => resolve({ availableCredits, currentPackage })),
    };
  } else {
    return {
      steps: [viewCreditsConfig],
      submitButtonText: null,
      cancelButtonText: "Close",
      mode: WizardMode.View,
      getInitialData: () =>
        new Promise((resolve) => resolve({ availableCredits, currentPackage })),
    };
  }
};
